import { Action } from '@ngrx/store';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import { IApiAutomationQueryParams } from '../shared/api-automation.model';
import { IApiAutomationOption } from '../shared/api-automation.model';
import {
  ILoadBalancerAllocation,
  ILoadBalancerAllocationRow,
} from '../../../../view/settings/api-automation-settings/load-balancer-allocations/load-balancer-allocations.model';

export enum ActionTypes {
  LOAD_BALANCER_ALLOCATIONS_DATA_LOADING = '[LOAD_BALANCER_ALLOCATIONS] LOAD_BALANCER_ALLOCATIONS DATA LOADING',
  LOAD_BALANCER_ALLOCATIONS_DATA_LOADED = '[LOAD_BALANCER_ALLOCATIONS] LOAD_BALANCER_ALLOCATIONS DATA LOADED',
  GET_LOAD_BALANCER_ALLOCATION = '[LOAD_BALANCER_ALLOCATIONS] GET_LOAD_BALANCER_ALLOCATION LOADING',
  GET_LOAD_BALANCER_ALLOCATION_COMPLETED = '[LOAD_BALANCER_ALLOCATIONS] GET_LOAD_BALANCER_ALLOCATION COMPLETED',
  ADD_LOAD_BALANCER_ALLOCATION = '[LOAD_BALANCER_ALLOCATIONS] ADD_LOAD_BALANCER_ALLOCATION',
  ADD_LOAD_BALANCER_ALLOCATION_COMPLETED = '[LOAD_BALANCER_ALLOCATIONS] ADD_LOAD_BALANCER_ALLOCATION COMPLETED',
  EDIT_LOAD_BALANCER_ALLOCATION = '[LOAD_BALANCER_ALLOCATIONS] EDIT_LOAD_BALANCER_ALLOCATION',
  EDIT_LOAD_BALANCER_ALLOCATION_COMPLETED = '[LOAD_BALANCER_ALLOCATIONS] EDIT_LOAD_BALANCER_ALLOCATION COMPLETED',
  DELETE_LOAD_BALANCER_ALLOCATIONS = '[LOAD_BALANCER_ALLOCATIONS] DELETE_LOAD_BALANCER_ALLOCATIONS',
  DELETE_LOAD_BALANCER_ALLOCATIONS_COMPLETED = '[LOAD_BALANCER_ALLOCATIONS] DELETE_LOAD_BALANCER_ALLOCATIONS COMPLETED',
  CHANNELS_DATA_LOADING = '[LOAD_BALANCER_ALLOCATIONS] CHANNELS DATA LOADING',
  CHANNELS_DATA_COMPLETED = '[LOAD_BALANCER_ALLOCATIONS] CHANNELS DATA COMPLETED',
  FETCH_ERROR = '[LOAD_BALANCER_ALLOCATIONS] FETCH ERROR',
}

export class LoadBalancerAllocationsLoading implements Action {
  readonly type = ActionTypes.LOAD_BALANCER_ALLOCATIONS_DATA_LOADING;

  constructor(public params: IApiAutomationQueryParams) {}
}

export class LoadBalancerAllocationsLoaded implements Action {
  readonly type = ActionTypes.LOAD_BALANCER_ALLOCATIONS_DATA_LOADED;

  constructor(public payload: GetManyResponseInterface<ILoadBalancerAllocation>) {}
}

export class GetLoadBalancerAllocation implements Action {
  readonly type = ActionTypes.GET_LOAD_BALANCER_ALLOCATION;

  constructor(public recordId: number) {}
}

export class GetLoadBalancerAllocationCompleted implements Action {
  readonly type = ActionTypes.GET_LOAD_BALANCER_ALLOCATION_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<ILoadBalancerAllocation>) {}
}
export class AddLoadBalancerAllocation implements Action {
  readonly type = ActionTypes.ADD_LOAD_BALANCER_ALLOCATION;

  constructor(
    public record: ILoadBalancerAllocationRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class AddLoadBalancerAllocationCompleted implements Action {
  readonly type = ActionTypes.ADD_LOAD_BALANCER_ALLOCATION_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<ILoadBalancerAllocation>) {}
}
export class EditLoadBalancerAllocation implements Action {
  readonly type = ActionTypes.EDIT_LOAD_BALANCER_ALLOCATION;

  constructor(
    public recordId: number,
    public record: ILoadBalancerAllocationRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class EditLoadBalancerAllocationCompleted implements Action {
  readonly type = ActionTypes.EDIT_LOAD_BALANCER_ALLOCATION_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<ILoadBalancerAllocation>) {}
}
export class DeleteLoadBalancerAllocations implements Action {
  readonly type = ActionTypes.DELETE_LOAD_BALANCER_ALLOCATIONS;

  constructor(public payload: number[]) {}
}

export class DeleteLoadBalancerAllocationsCompleted implements Action {
  readonly type = ActionTypes.DELETE_LOAD_BALANCER_ALLOCATIONS_COMPLETED;

  constructor(
    public isBulk: boolean,
    public response: BulkResponseDataInterface,
  ) {}
}
export class ChannelsDataLoading implements Action {
  readonly type = ActionTypes.CHANNELS_DATA_LOADING;
}

export class ChannelsDataCompleted implements Action {
  readonly type = ActionTypes.CHANNELS_DATA_COMPLETED;

  constructor(public payload: IApiAutomationOption[]) {}
}
export class FetchError implements Action {
  readonly type = ActionTypes.FETCH_ERROR;

  constructor(public errorAction: ActionTypes) {}
}

export type LoadBalancerAllocationActions =
  | LoadBalancerAllocationsLoading
  | LoadBalancerAllocationsLoaded
  | GetLoadBalancerAllocation
  | GetLoadBalancerAllocationCompleted
  | AddLoadBalancerAllocation
  | AddLoadBalancerAllocationCompleted
  | EditLoadBalancerAllocation
  | EditLoadBalancerAllocationCompleted
  | DeleteLoadBalancerAllocations
  | DeleteLoadBalancerAllocationsCompleted
  | ChannelsDataLoading
  | ChannelsDataCompleted
  | FetchError;
